// Mock data for the Travel CRM system

export const leadSources = [
  { id: 'website', name: 'Web', color: '#667eea', icon: '💻' },
  { id: 'meta_ads', name: 'MAds', color: '#1877f2', icon: '📱' },
  { id: 'google_ads', name: 'GAds', color: '#4285f4', icon: '🎯' },
  { id: 'manual', name: 'Manual', color: '#48bb78', icon: '📝' }
];

export const leadStatuses = [
  { id: 'new', name: 'New Lead', icon: '✨', color: '#667eea' },         // OK
  { id: 'follow_up', name: 'Follow Up', icon: '🔔', color: '#2b6cb0' },  // Calm blue for ongoing action  
  { id: 'hot_lead', name: 'Hot Lead', icon: '🔥', color: '#FF5722' },    // OK
  { id: 'process', name: 'Process', icon: '🔄', color: '#9C27B0' },      // OK
  { id: 'not_interested', name: 'Not Interested', icon: '🚫', color: '#718096' }, // Neutral gray for inactivity  
  { id: 'call_not_answered', name: 'Call Not Answered', icon: '🔴', color: '#d53f8c' }, // Bold red for missed call  
  { id: 'cancelled', name: 'Cancelled', icon: '❌', color: '#795548' },  // OK
  { id: 'finalised', name: 'Finalised', icon: '💛', color: '#4CAF50' },  // OK
];

export const userRoles = [
  { id: 'admin', name: 'Admin', permissions: ['all'] },
  { id: 'user', name: 'User', permissions: ['view_own_leads', 'edit_own_leads'] }
];

export const mockLeads = [
  {
    id: 'LD001',
    source: 'website',
    createdDate: '2025-06-12',
    createdTime: '10:30:00',
    name: 'Alice Cooper',
    emails: [
      { value: 'alice.cooper@email.com', isPrimary: true, addedBy: 'system', addedAt: '2024-01-15T10:30:00Z' }
    ],
    phones: [
      { value: '+1 234 567 8901', isPrimary: true, addedBy: 'system', addedAt: '2024-01-15T10:30:00Z' }
    ],
    tourName: 'Paris Romantic Getaway',
    numberOfPax: 2,
    travelDate: '2024-02-14',
    message: 'Looking for a romantic Valentine\'s trip to Paris with my partner.',
    ownerId: null,
    status: 'new',
    isNewLead: true,
    timeline: [
      {
        id: 1,
        action: 'Lead Created',
        description: 'Lead received from Website',
        userId: 'system',
        userName: 'System',
        timestamp: '2024-01-15T10:30:00Z'
      }
    ],
    comments: []
  },
  {
    id: 'LD002',
    source: 'meta_ads',
    createdDate: '2024-01-15',
    createdTime: '09:15:00',
    name: 'Robert Johnson',
    emails: [
      { value: 'robert.j@gmail.com', isPrimary: true, addedBy: 'system', addedAt: '2024-01-15T09:15:00Z' }
    ],
    phones: [
      { value: '+1 234 567 8902', isPrimary: true, addedBy: 'system', addedAt: '2024-01-15T09:15:00Z' }
    ],
    tourName: 'Tokyo Adventure Package',
    numberOfPax: 4,
    travelDate: '2024-03-20',
    message: 'Family trip to Tokyo, need package for 2 adults and 2 kids.',
    ownerId: null,
    status: 'closed',
    isNewLead: false,
    timeline: [
      {
        id: 1,
        action: 'Lead Created',
        description: 'Lead received from Meta Ads',
        userId: 'system',
        userName: 'System',
        timestamp: '2024-01-15T09:15:00Z'
      },
      {
        id: 2,
        action: 'Status Updated',
        description: 'Status changed from New to Closed',
        userId: 'system',
        userName: 'System',
        timestamp: '2024-01-15T10:45:00Z'
      }
    ],
    comments: [
      {
        id: 1,
        text: 'Customer is very closed, planning to call today.',
        userId: 'system',
        userName: 'System',
        timestamp: '2024-01-15T10:45:00Z'
      }
    ]
  },
  {
    id: 'LD003',
    source: 'google_ads',
    createdDate: '2024-01-14',
    createdTime: '16:20:00',
    name: 'Emily Davis',
    emails: [
      { value: 'emily.davis@outlook.com', isPrimary: true, addedBy: 'system', addedAt: '2024-01-14T16:20:00Z' }
    ],
    phones: [
      { value: '+1 234 567 8903', isPrimary: true, addedBy: 'system', addedAt: '2024-01-14T16:20:00Z' },
      { value: '+1 234 567 8904', isPrimary: false, addedBy: 'system', addedAt: '2024-01-14T17:30:00Z' }
    ],
    tourName: 'Bali Wellness Retreat',
    numberOfPax: 1,
    travelDate: '2024-04-15',
    message: 'Solo traveler looking for wellness and spa package in Bali.',
    ownerId: null,
    status: 'under_process',
    isNewLead: false,
    timeline: [
      {
        id: 1,
        action: 'Lead Created',
        description: 'Lead received from Google Ads',
        userId: 'system',
        userName: 'System',
        timestamp: '2024-01-14T16:20:00Z'
      },
      {
        id: 2,
        action: 'Status Updated',
        description: 'Status changed from New to Closed',
        userId: 'system',
        userName: 'System',
        timestamp: '2024-01-14T17:00:00Z'
      },
      {
        id: 3,
        action: 'Additional Info Added',
        description: 'Added alternative phone number',
        userId: 'system',
        userName: 'System',
        timestamp: '2024-01-14T17:30:00Z'
      },
      {
        id: 4,
        action: 'Status Updated',
        description: 'Status changed from Closed to Under Process',
        userId: 'system',
        userName: 'System',
        timestamp: '2024-01-15T09:00:00Z'
      }
    ],
    comments: [
      {
        id: 1,
        text: 'Customer called, very specific about wellness requirements.',
        userId: 'system',
        userName: 'System',
        timestamp: '2024-01-14T17:00:00Z'
      },
      {
        id: 2,
        text: 'Preparing custom package. Follow up scheduled for tomorrow.',
        userId: 'system',
        userName: 'System',
        timestamp: '2024-01-15T09:00:00Z'
      }
    ]
  }
];

// Helper functions to get data
export const getLeadsByOwnerId = (ownerId) => {
  return mockLeads.filter(lead => lead.ownerId === ownerId);
};

export const getUnassignedLeads = () => {
  return mockLeads.filter(lead => lead.ownerId === null);
};

export const getLeadsByStatus = (status) => {
  return mockLeads.filter(lead => lead.status === status);
};

export const getLeadsBySource = (source) => {
  return mockLeads.filter(lead => lead.source === source);
};

export const getLeadSourceById = (sourceId) => {
  return leadSources.find(source => source.id === sourceId);
};

export const getStatusById = (statusId) => {
  return leadStatuses.find(status => status.id === statusId);
}; 